import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import ReactTooltip from "react-tooltip";
import Table from "../../common/components/Table";
import refreshIcon from "../../../assets/img/img-refresh.svg";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";
import moment from "moment";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import { taskManagerTableData } from "./tableConfig";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import SmartChartLog from "./SmartChartLog";
import GlobalSearch from "../../common/components/GlobalSearch";
import MasterFilter from "../components/MasterFilterForSmartChartList";
import { checkPermission, showAlert as showAlertUtil } from "../../../config/utils";
import { permissions } from "../../../config/permissions";
import TableTopIcons from "../../common/components/TableTopIcons";

const TaskManager = ({ getSmartChartMasterFilterDropDown, masterFilterList, mFilters, updateMfilterForSmartChartList, resetAllFilters }) => {
    const [tableData, setTableData] = useState({
        keys: taskManagerTableData.keys,
        data: [],
        config: taskManagerTableData.config
    });
    const [confirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [selectedDeleteTaskById, setSelectedDeleteTaskById] = useState(false);
    const [showConfirmEndTask, setShowConfirmEndTask] = useState(false);
    const [selectedEndTask, setSelectedEndTask] = useState(null);
    const [alertMessage, setAlertMessage] = useState("");
    const [clearTaskModal, setClearTaskModal] = useState(false);
    const [hasLogId, setHasLogId] = useState(null);
    const [showLogModal, setShowLogModal] = useState(false);
    const [showWildCardFilter, setShowWildCardFilter] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    const [params, setParams] = useState({
        page: 1,
        limit: 15,
        search: "",
        // sort_by: "created_date",
        client_ids: mFilters?.client_ids,
        order: {},
        filters: null,
        list: {}
    });

    const dispatch = useDispatch();

    const { getTaskManagerResponse, deleteTaskManagerByIdResponse, updateEndTaskManagerResponse, clearTaskResponse, taskManagerTableFilterResponse } =
        useSelector(state => state.smartChartReducer) || {};

    const totalPages = Math.ceil(getTaskManagerResponse?.count / params?.limit);

    const fetchTaskManagerList = () => {
        const apiPayload = {
            per_page_count: params.limit,
            page_number: params.page,
            search: params?.search,
            sort_by: params.sort_by,
            filter: params?.filters,
            ...(params?.order && Object.keys(params.order)?.length > 0 && { sort_order: params.order }),

            client_ids: params?.client_ids,
            ...(params?.exportParams?.status && { status_ids: params?.exportParams.status }),
            ...(params?.exportParams?.user && { user_ids: params?.exportParams.user }),
            ...(params?.exportParams?.task_type && { task_type_ids: params?.exportParams.task_type }),
            ...(params?.exportParams?.task_name && { task_name: params?.exportParams.task_name })
        };

        dispatch(actions.getTaskManagerList(apiPayload));
    };

    const resetFilter = () => {
        setParams({
            page: 1,
            limit: 15,
            search: "",
            client_ids: mFilters.client_ids,
            order: {}
        });
        setShowWildCardFilter(false);
        // resetAllFilters();
    };

    const resetTableAllFilter = async () => {
        setParams(prevParams => ({
            ...prevParams,
            filters: null,
            exportParams: null,
            list: {}
        }));
    };

    const handlePageClick = selected => {
        setParams(prevParams => ({
            ...prevParams,
            page: selected?.selected + 1
        }));
    };

    const handleLimitChange = e => {
        setParams(prevParams => ({
            ...prevParams,
            limit: Number(e.target.value),
            page: 1
        }));
    };

    const toggleWildCardFilter = () => {
        setShowWildCardFilter(!showWildCardFilter);
    };

    const resetSort = async () => {
        setParams(prevParams => ({
            ...prevParams,
            order: {}
        }));
    };

    useEffect(() => {
        if (mFilters?.client_ids) {
            setParams({
                page: 1,
                limit: 15,
                search: "",
                client_ids: mFilters.client_ids,
                order: {}
            });
        }
    }, [mFilters?.client_ids]);

    useEffect(() => {
        fetchTaskManagerList();
    }, [params]);

    useEffect(() => {
        if (getTaskManagerResponse?.data) {
            const formattedData = getTaskManagerResponse.data?.map(item => {
                return {
                    ...item,
                    date_initiated: item?.date_initiated
                        ? moment(item?.date_initiated).isValid()
                            ? moment(item?.date_initiated).format("MM-DD-YYYY hh:mm A")
                            : null
                        : null,
                    date_done: item?.date_done
                        ? moment(item?.date_done).isValid()
                            ? moment(item?.date_done).format("MM-DD-YYYY hh:mm A")
                            : null
                        : null
                };
            });

            setTableData({
                keys: taskManagerTableData.keys,
                data: formattedData,
                config: taskManagerTableData.config
            });
        } else if (typeof getTaskManagerResponse?.detail === "string") setAlertMessage(getTaskManagerResponse?.detail);
    }, [getTaskManagerResponse]);

    const showAlert = () => {
        showAlertUtil(alertMessage);
        setTimeout(() => setAlertMessage(""), 3000);
    };

    const getListForCommonFilter = async (paramsVal, a, b) => {
        const { [paramsVal?.field]: omit, ...tempParams } = params?.exportParams ?? {};
        let entityParams = {
            ...(mFilters?.client_ids && { client_ids: mFilters?.client_ids }),
            ...(tempParams?.task_name && { task_name: tempParams.task_name }),
            ...(tempParams?.status && { status_ids: tempParams.status }),
            ...(tempParams?.user && { user_ids: tempParams.user }),
            ...(tempParams?.task_type && { task_type_ids: tempParams.task_type }),
            ...(tempParams?.task_name && { task_name: tempParams?.task_name })
        };
        const { search, filters } = params;

        const updatedParams = {
            search,
            filters
        };

        const combinedParams = { ...updatedParams, ...paramsVal };

        await dispatch(actions.getTaskTableFilter(combinedParams, entityParams));
        return [];
    };

    const updateCommonFilter = async (list, exportParams) => {
        setParams(prevParams => ({
            ...prevParams,
            offset: 1,
            list,
            exportParams: list ? exportParams : undefined,
            page: 1,
            client_ids: mFilters?.client_ids || []
        }));
    };

    const hasEndTask = async id => {
        setShowConfirmEndTask(true);
        setSelectedEndTask(id);
    };

    const onHasLog = async id => {
        setShowLogModal(true);
        setHasLogId(id);
    };

    const updateWildCardFilter = async newFilter => {
        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            filters: newFilter
        }));
    };

    const updateTableSortFilters = async (searchKey, a, b) => {
        setParams(prevParams => ({
            ...prevParams,
            order: {
                ...prevParams.order,
                [searchKey]: prevParams.order[searchKey] === "desc" ? "asc" : "desc"
            }
        }));
    };

    const handleGlobalSearch = async search => {
        setParams({
            ...params,
            page: 1,
            search
        });
    };

    const handleDeleteFloor = async id => {
        setShowConfirmDeleteModal(true);
        setSelectedDeleteTaskById(id);
    };

    const clearTaskOnConfirm = async () => {
        const clientId = Array.isArray(params?.client_ids) ? params.client_ids[0] : String(params?.client_ids);

        await dispatch(
            actions.clearAllTaskManager(clientId, () => {
                fetchTaskManagerList();
                setAlertMessage("Tasks Cleared Successfully");
            })
        );
        if (!clearTaskResponse?.success) {
            setAlertMessage(clearTaskResponse?.detail);
        }
        setClearTaskModal(false);
    };

    const deleteFloorOnConfirm = async () => {
        await dispatch(
            actions.deleteTaskManagerById(selectedDeleteTaskById, () => {
                fetchTaskManagerList();
                setSelectedDeleteTaskById(null);
                setAlertMessage("Task Deleted Successfully");
            })
        );
        if (!deleteTaskManagerByIdResponse?.success) {
            setAlertMessage(deleteTaskManagerByIdResponse?.detail);
        }

        setShowConfirmDeleteModal(false);
    };

    const onEndTaskManager = async () => {
        await dispatch(
            actions.updateEndTaskManager({ task_id: selectedEndTask }, () => {
                fetchTaskManagerList();
                setSelectedEndTask(null);
                setAlertMessage("Task Ended Successfully");
            })
        );
        if (!updateEndTaskManagerResponse?.success) {
            setAlertMessage(updateEndTaskManagerResponse?.detail);
        }
        setShowConfirmEndTask(false);
    };

    const renderSmartChartLogModal = () => {
        if (!showLogModal) return null;

        return (
            <Portal
                body={
                    <SmartChartLog
                        smartChartLog={showLogModal}
                        onShow={() => setShowLogModal(true)}
                        onCancel={() => setShowLogModal(false)}
                        selectedReportId={hasLogId}
                    />
                }
                onCancel={() => {
                    setShowLogModal(false);
                    setHasLogId(null);
                }}
            />
        );
    };

    const renderdeleteByIdConfirmationModal = () => {
        if (!confirmDeleteModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to delete this Task from list?"}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() => setShowConfirmDeleteModal(false)}
                        onYes={deleteFloorOnConfirm}
                    />
                }
                onCancel={() => setShowConfirmDeleteModal(false)}
            />
        );
    };

    const renderClearTaskConfirmationModal = () => {
        if (!clearTaskModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            "Do you want to clear All task? Clearing the tasks will only remove them from the Task Manager's list ,the processes will continue running."
                        }
                        message={"This action cannot be reverted, are you sure that you need to clear all this item?"}
                        onNo={() => setClearTaskModal(false)}
                        onYes={clearTaskOnConfirm}
                    />
                }
                onCancel={() => setClearTaskModal(false)}
            />
        );
    };

    const renderEndTaskConfirmationModal = () => {
        if (!showConfirmEndTask) return null;

        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={`Are you sure you want to End the task?`}
                        message={"Are you sure you want to proceed?"}
                        onNo={() => setShowConfirmEndTask(false)}
                        onYes={onEndTaskManager}
                        cancel={() => setShowConfirmEndTask(false)}
                    />
                }
                onCancel={() => setShowConfirmEndTask(false)}
            />
        );
    };

    useEffect(() => {
        alertMessage && showAlert();
    }, [alertMessage]);

    return (
        <React.Fragment>
            <LoadingOverlay active={getTaskManagerResponse?.isLoading} spinner={<Loader />} fadeSpeed={10}>
                <div className="tab-active recomdn-table">
                    <div className="dtl-sec col-md-12 mt-0 p-2 ">
                        <div className="table-top-menu allign-right">
                            <div className="lft">
                                {" "}
                                <MasterFilter
                                    getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                                    masterFilterList={masterFilterList?.smart_task_manager_list_filter}
                                    selectedFiltersList={mFilters}
                                    updateMfilterForSmartChartList={updateMfilterForSmartChartList}
                                    filterEntity="smart_task_manager_list_filter"
                                />
                            </div>
                            <div className="rgt">
                                <TableTopIcons
                                    tableParams={params}
                                    hasSort
                                    // resetAll={resetFilter}
                                    tableData={tableData}
                                    globalSearchKey={params.search}
                                    handleGlobalSearch={handleGlobalSearch}
                                    hasView={false}
                                    toggleWildCardFilter={toggleWildCardFilter}
                                    resetSort={resetSort}
                                    showWildCardFilter={showWildCardFilter}
                                    hasWildCardFilter
                                    resetAllFilters={resetTableAllFilter}
                                    showViewModal={() => setShowViewModal(!showViewModal)}
                                />

                                <button
                                    className="btn btn-edit btn-refresh mr-1"
                                    onClick={e => {
                                        e.preventDefault();
                                        fetchTaskManagerList();
                                    }}
                                >
                                    <span className="icon mr-1">
                                        <img src={refreshIcon} alt="" />
                                    </span>
                                    <span className="text">Refresh</span>
                                </button>

                                <button
                                    className="btn btn-edit btn-refresh mr-1"
                                    onClick={e => {
                                        e.preventDefault();
                                        resetFilter();
                                    }}
                                >
                                    <span className="text">Reset Filters & Sort</span>
                                </button>

                                {/* {tableData?.data?.length > 0 && checkPermission("forms", permissions.SMART_CHART_TASK_MANAGER, "hard_delete") && (
                                    <button
                                        className="btn  btn-danger mr-1 py-2"
                                        onClick={e => {
                                            e.preventDefault();
                                            setClearTaskModal(true);
                                        }}
                                    >
                                        <span className="text">Clear All</span>
                                    </button>
                                )} */}
                            </div>
                        </div>
                        <div className="table-section site-table  brd-section ">
                            <Table
                                noFutureDate
                                showWildCardFilter={showWildCardFilter}
                                updateWildCardFilter={updateWildCardFilter}
                                wildCardFilter={params?.filters}
                                isTaskManager
                                additionalTableClass="taskmange"
                                tableData={tableData}
                                hasEdit={false}
                                updateSelectedRow={() => null}
                                hasDelete={checkPermission("forms", permissions.SMART_CHART_TASK_MANAGER, "hard_delete")}
                                handleDeleteItem={handleDeleteFloor}
                                hasEndTask={checkPermission("forms", permissions.SMART_CHART_TASK_MANAGER, "edit") && hasEndTask}
                                hasLog={onHasLog}
                                showInfoPage={false}
                                hasInfoPage={false}
                                tableActionClass=" text-center wide-act-3"
                                getListForCommonFilter={getListForCommonFilter}
                                commonFilterData={taskManagerTableFilterResponse || {}}
                                isNewTableFilters
                                updateCommonFilter={updateCommonFilter}
                                exportFilters={params?.exportParams}
                                commonFilter={params?.list}
                                updateTableSortFilters={updateTableSortFilters}
                                tableParams={params}
                            />

                            {tableData.data && tableData.data.length ? (
                                <div className="table-bottom d-flex">
                                    <div className="count d-flex col-md-6">
                                        <div className="count-dtl">
                                            Total Count: <span>{getTaskManagerResponse?.count}</span>
                                        </div>
                                        <div className="col-md-2 pr-2 selbx">
                                            <select className="form-control" value={params?.limit} onChange={handleLimitChange}>
                                                {[15, 20, 30, 40, 50, 100, 150]?.map(limit => (
                                                    <option key={limit} value={limit}>
                                                        {limit}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pagination-sec col-md-6">
                                        <ReactPaginate
                                            previousLabel={
                                                <span data-place="top" data-effect="solid" data-tip={"Previous"} data-background-color="#007bff">
                                                    &lt;
                                                </span>
                                            }
                                            nextLabel={
                                                <span data-place="top" data-effect="solid" data-tip={"Next"} data-background-color="#007bff">
                                                    &gt;
                                                </span>
                                            }
                                            pageCount={totalPages}
                                            breakLabel={"..."}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                        />
                                        <ReactTooltip />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                {renderdeleteByIdConfirmationModal()}
                {renderEndTaskConfirmationModal()}
                {renderClearTaskConfirmationModal()}
                {renderSmartChartLogModal()}
            </LoadingOverlay>
        </React.Fragment>
    );
};

export default TaskManager;
